const setupFilterForm = (form) => {
  if (form.dataset.filterFormReady === 'true') {
    return;
  }

  form.addEventListener('change', (event) => {
    const field = event.target.closest('input, select, textarea');

    if (!field || !form.contains(field) || field.disabled) {
      return;
    }

    form.requestSubmit();
  });

  form.dataset.filterFormReady = 'true';
};

const bootstrapFilterForms = () => {
  const forms = document.querySelectorAll('.js-filter-form');
  forms.forEach((form) => setupFilterForm(form));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapFilterForms);
} else {
  bootstrapFilterForms();
}
